export const styles = {
  inputStyle: {
    pr: 6,
    '& input': {
      minWidth: 0,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
};

